import { Component, OnDestroy, OnInit } from '@angular/core';
import * as EmployeeActions from './../../store/employee/employee.actions';
import { EmployeeState } from '../../store/employee/employee.reducer';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Predicate } from '@ngrx/entity';
import * as fromEmployeeSelectors from '../../store/employee/employee.selectors'
import {Department, EmployeeJobCode, IEmployee} from '@signal/asp-data-commons';
import { ActivatedRoute } from '@angular/router';
import { unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-service-advisor',
  templateUrl: './service-advisor.component.html',
  styleUrls: ['./service-advisor.component.scss']
})
export class ServiceAdvisorComponent implements OnInit,OnDestroy {

  isLoading$: Observable<boolean>;
  activeAdvisors$: Observable<IEmployee[]>;
  inActiveAdvisors$: Observable<IEmployee[]>;
  activeTechnicians$: Observable<IEmployee[]>;
  inActiveTechnicians$: Observable<IEmployee[]>;
  viewMode = 'advisors';
  isSyncStatusLoading$: Observable<boolean>;
  syncStatus$: Observable<string>;
  lastSyncedAt$: Observable<string>;
  refreshInterval;
  private subs:SubscriptionList = {};
  private isStaffMasterSyncInProgress = false;

  constructor(private readonly employeeStore: Store<EmployeeState>,
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertService) {
    //this.dispatchActions();
  }

  ngOnInit() {
    this.subs.route = this.route.queryParamMap.subscribe((params:any) => {
      if(params.params.tab){
        this.viewMode = 'technicians';
      }
    });
    this.setupStore()
  }

  private setupStore() {
    /* Store actions dispatchers */
    this.dispatchActions();
    /* Predicates */
    const activeAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.ADVISOR
        && e.isActive;

    const inActiveAdvisorPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.ADVISOR
        && !e.isActive;

    const activeTechnicianPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.TECHNICIAN
        && e.isActive;

    const inActiveTechnicianPredicate: Predicate<IEmployee> =
      (e: IEmployee) => e.department === Department.SERVICE
        && e.jobCode === EmployeeJobCode.TECHNICIAN
        && !e.isActive;

    this.isSyncStatusLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectIsSyncStatusLoading);
    this.syncStatus$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatus);
    this.subs.syncstatus = this.syncStatus$.subscribe(status=>{
      if (status === 'SYNC_COMPLETED') {
        if (this.isStaffMasterSyncInProgress) {
          this.alertService.showAlert('otherTexts.syncedSuccessfully', '', '', 5000, false);
        }
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      } else if (status === 'SYNC_FAILED') {
        this.isStaffMasterSyncInProgress = false;
        clearInterval(this.refreshInterval);
      }
    })
    this.lastSyncedAt$ = this.employeeStore.select(fromEmployeeSelectors.selectSyncStatusLastSyncedAt);
    this.isLoading$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesLoading);
    this.activeAdvisors$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: activeAdvisorPredicate });
    this.inActiveAdvisors$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: inActiveAdvisorPredicate });

    this.activeTechnicians$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: activeTechnicianPredicate });
    this.inActiveTechnicians$ = this.employeeStore.select(fromEmployeeSelectors.selectEmployeesByPredicate, { predicate: inActiveTechnicianPredicate });
  }

  private dispatchActions() {
    this.employeeStore.dispatch(new EmployeeActions.LoadEmployees());
    this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
  }

  triggerStaffMasterSync() {
    this.isStaffMasterSyncInProgress = true;
    this.employeeStore.dispatch(new EmployeeActions.TriggerStaffMasterSync());
    this.refreshInterval = setInterval(() => {
      this.employeeStore.dispatch(new EmployeeActions.LoadStaffMasterSyncStatus());
    }, 10 * 1000)
  }

  ngOnDestroy(){
    unsubscribeSubscriptions(this.subs);
  }
}
